import React from 'react';
import RightSideHeader from './rightSideHeader';
import { styles } from './styles';
import logo from '../../img/headerLogo.png';
import logonkc from '../../img/nkc.png';
import config from '../../config/config';
import logoDlb from '../../img/djb.png'
const Header = () => {
  return (
    <header className='header'>
      <div style={styles.headerSubContainer}>
        <div style={styles.logoContainer}>
          {
            config.NkcWeb && 
            <img src={logonkc} alt='header_icon' />
          }
          {
            config.VTSWeb && 
            <img src={logo} alt='header_icon' />
          }
          {
            config.BJBWeb && 
            <img src={logoDlb} alt='header_icon' />
          }
        </div>
        <RightSideHeader/>
      </div>
    </header>
  )
}

export default Header;
